import { Viewer, Worker } from '@react-pdf-viewer/core'
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import React, { FC } from 'react'

interface Props {
    documentData: any
    setCheckedDocuments: (data: any) => void;
}

const ViewPendingFile: FC<Props> = ({ documentData, setCheckedDocuments }) => {

    const token: any = localStorage.getItem("token");

    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer

                fileUrl={`https://mainhub.insuhub.ch/api/costumers/pendings/show-file/${documentData}`}
                renderLoader={() => (
                    <div className="min-h-[500px]">
                        <LoadingScreen />
                    </div>
                )}
                httpHeaders={{
                    Authorization: `Bearer ${token}`
                }}
            />
        </Worker>
    )
}

export default ViewPendingFile